export const APP_SETTINGS = {
  layout: "",
  container: "fixed",
  layouts: {
    headerSticky: true,
    headerStickyOffset: 200,
  },
};
